export default "__VITE_ASSET__DpffJ8Y3__"